import { Component, input, output } from '@angular/core';

type ButtonTheme = 'primary' | 'secondary';
type ButtonType = 'button' | 'submit';

@Component({
  selector: 'ez-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  readonly label = input<string>();
  readonly theme = input<ButtonTheme>('primary');
  readonly buttonType = input<ButtonType>('submit');
  readonly disabled = input<boolean>(false);
  readonly maxWidth = input<string>('100%');
  readonly loading = input<boolean>(false);
  readonly buttonClick = output<MouseEvent>();

  onClickButton(event: MouseEvent) {
    this.buttonClick.emit(event);
  }
}
